import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core';

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	bannerElements && new Splide('.js-banner-slider', {
		type: 'loop',
		arrows: false,
		pagination: true,
		keyboard: false,
		drag: true,
		rewind: true,
		autoplay: true,
		speed: 1000,
		interval: 5000,
		pauseOnHover: false,
		snap: true,
		classes: {
			pagination: 'splide__pagination dots-parent justify-center absolute bottom-10 left-[50%] translate-x-[-50%]',
			page: 'splide__pagination__page dots dots-white'
		},
	}).mount()

	// --- Case Study Slider ---
	const caseStudyElements = document.querySelectorAll('.js-case-study-slider.js-not-cvm-slider')
	if (caseStudyElements) {
		caseStudyElements.forEach((element) => {
			new Splide(element, {
				type: 'slide',
				arrows: false,
				pagination: true,
				keyboard: false,
				drag: true,
				rewind: true,
				autoplay: false,
				speed: 1000,
				gap: 20,
				interval: 5000,
				pauseOnHover: true,
				snap: true,
				classes: {
					pagination: 'splide__pagination !dots-parent !justify-start !mt-5',
					page: 'splide__pagination__page !dots !dots-primary'
				},
			}).mount()
		});
	}

	const caseStudyElementsCvm = document.querySelectorAll('.js-case-study-slider.js-cvm-slider')
	if (caseStudyElementsCvm) {
		caseStudyElementsCvm.forEach((element) => {
			new Splide(element, {
				type: 'slide',
				arrows: false,
				pagination: true,
				keyboard: false,
				drag: true,
				rewind: true,
				autoplay: false,
				speed: 1000,
				gap: 20,
				interval: 5000,
				pauseOnHover: true,
				snap: true,
				classes: {
					pagination: 'splide__pagination !dots-parent !justify-start !mt-5',
					page: 'splide__pagination__page !dots !dots-white'
				},
			}).mount()
		});
	}
	// --- USP Slider ---
	const uspElements = document.querySelector('.js-usp-slider')
	uspElements && new Splide('.js-usp-slider', {
		type: 'slide',
		perPage: 1,
		perMove: 1,
		pagination: false,
		gap: 20,
		arrows: false,
		mediaQuery: 'min',
		breakpoints: {
			767: {
				perPage: 2,
			},
			1023: {
				perPage: 3,
			},
		},
	}).mount()

	// --- Logos Slider ---
	const logos = document.querySelectorAll('.js-logos-slider')
	if (logos.length) {
		for (let i = 0; i < logos.length; i++) {
			const isDark = logos[i].dataset.background === 'primary'

			new Splide(logos[i], {
				type: 'loop',
				perPage: 1,
				perMove: 1,
				gap: 20,
				pagination: true,
				arrows: true,
				mediaQuery: 'min',
				autoplay: true,
				speed: 1000,
				interval: 5000,
				breakpoints: {
					450: {
						perPage: 2,
					},
					767: {
						perPage: 3,
						gap: 40,
					},
					1023: {
						perPage: 4,
					},
				},
				classes: {
					pagination: 'splide__pagination relative z-10 !dots-parent !justify-center !mt-7',
					page: `splide__pagination__page !dots ${isDark ? '!dots-white' : '!dots-primary'}`
				},
			}).mount()
		}
	}


	// --- Product Feed Sliders ---
	const productFeed = document.querySelectorAll('.js-product-slider.js-not-cvm-slider')
	if(productFeed.length) {
		for (let i = 0; i < productFeed.length; i++) {
			const autoplay = productFeed[i].dataset.autoplay === 'true' ? true : false

			new Splide(productFeed[i], {
				type: autoplay ? 'loop' : 'slide',
				perPage: 1,
				perMove: 1,
				gap: 20,
				pagination: true,
				arrows: true,
				mediaQuery: 'min',
				autoplay: autoplay,
				speed: 1000,
				interval: 2500,
				breakpoints: {
					480: {
						perPage: 2,
					},
					767: {
						perPage: 3,
					},
					1279: {
						perPage: 4,
					},
				},
				classes: {
					pagination: 'splide__pagination relative z-10 !dots-parent !justify-center !mt-7',
					page: 'splide__pagination__page !dots !dots-primary'
				},
			}).mount()
		}
	}

	const productFeedCvm = document.querySelectorAll('.js-product-slider.js-cvm-slider')
	if(productFeedCvm.length) {
		for (let i = 0; i < productFeedCvm.length; i++) {
			new Splide(productFeedCvm[i], {
				type: 'slide',
				perPage: 1,
				perMove: 1,
				gap: 20,
				pagination: true,
				arrows: true,
				mediaQuery: 'min',
				autoplay: false,
				breakpoints: {
					480: {
						perPage: 2,
					},
					767: {
						perPage: 3,
					},
					1279: {
						perPage: 4,
					},
				},
				classes: {
					pagination: 'splide__pagination relative z-10 !dots-parent !justify-center !mt-7',
					page: 'splide__pagination__page !dots !dots-white'
				},
			}).mount()
		}
	}


	// --- Timeline Feed Sliders ---
	const timeline = document.querySelectorAll('.js-timeline-slider')
	if(timeline.length) {
		for (let i = 0; i < timeline.length; i++) {
			new Splide(timeline[i], {
				type: 'slide',
				perPage: 1,
				perMove: 1,
				gap: 0,
				pagination: true,
				arrows: false,
				mediaQuery: 'min',
				autoplay: false,
				breakpoints: {
					767: {
						perPage: 2,
					},
					1023: {
						perPage: 3,
					},
					1279: {
						perPage: 4,
					},
				},
				classes: {
					pagination: 'splide__pagination !dots-parent !justify-start !mt-5',
					page: 'splide__pagination__page !dots !dots-white'
				},
			}).mount()
		}
	}

	// --- Gallery Sliders ---
	const gallery = document.querySelectorAll('.js-gallery-slider')
	if (gallery.length) {
		for (let i = 0; i < gallery.length; i++) {
			const gallerySlider = new Splide(gallery[i], {
				type: 'slide',
				perPage: 1,
				perMove: 1,
				gap: 0,
				pagination: true,
				arrows: false,
				mediaQuery: 'min',
				autoplay: false,
				observer: true,
				observeParents: true,
				classes: {
					pagination: 'splide__pagination !dots-parent !justify-start !mt-5 !xl:mt-10',
					page: 'splide__pagination__page !dots !dots-primary'
				},
			}).mount()

			// if click .js-refresh-slider, refresh the slider
			const refreshSlider = document.querySelector('.js-refresh-slider')
			refreshSlider && refreshSlider.addEventListener('click', () => {
				gallerySlider.refresh()
			})
		}
	}

	// --- Energy Images Slider ---
	const energyImages = document.querySelector('.js-energy-images-slider')
	energyImages && new Splide('.js-energy-images-slider', {
		type: 'loop',
		arrows: false,
		pagination: true,
		keyboard: false,
		drag: true,
		rewind: true,
		autoplay: true,
		speed: 1000,
		interval: 5000,
		pauseOnHover: false,
		snap: true,
		classes: {
			pagination: 'splide__pagination dots-parent justify-end absolute bottom-5 right-5',
			page: 'splide__pagination__page dots dots-grey'
		},
	}).mount()

	// --- Energy Images Slider ---
	const calcImages = document.querySelector('.js-calc-images-slider')
	calcImages && new Splide('.js-calc-images-slider', {
		type: 'slide',
		arrows: true,
		pagination: true,
		keyboard: false,
		drag: true,
		rewind: true,
		autoplay: true,
		speed: 1000,
		gap: 20,
		interval: 5000,
		pauseOnHover: false,
		snap: true,
		classes: {
			pagination: 'splide__pagination dots-parent justify-center absolute bottom-8 sm:bottom-12 left-1/2 -translate-x-1/2 right-5',
			page: 'splide__pagination__page dots dots-white'
		},
	}).mount()

	const productGallery = document.querySelector('.js-product-gallery-main')
	const productGalleryThumbs = document.querySelector('.js-product-gallery-thumbs')

	if (productGallery && productGalleryThumbs) {
		let main = new Splide(productGallery, {
			type: 'slide',
			arrows: true,
			pagination: false,
			perPage: 1,
			perMove: 1,
			autoplay: false
		});
		let thumbs = new Splide(productGalleryThumbs, {
			type: 'slide',
			isNavigation: true,
			gap: 10,
			pagination: false,
			perPage: 4,
			arrows: false,
			mediaQuery: 'min',
			breakpoints: {
				767: {
					perPage: 6,
				},
			}
		});
		main.sync(thumbs);
		main.mount();
		thumbs.mount();
	}

	const teamSlider = document.querySelector('.js-team-slider')
	teamSlider && new Splide('.js-team-slider', {
		type: 'slide',
		arrows: true,
		perPage: 1,
		pagination: true,
		keyboard: false,
		drag: true,
		gap: 20,
		snap: true,
		mediaQuery: 'min',
		classes: {
			pagination: 'splide__pagination relative z-10 !dots-parent !justify-center !mt-7',
			page: 'splide__pagination__page !dots !dots-primary'
		},
		breakpoints: {
			639: {
				perPage: 2,
			},
			1023: {
				perPage: 3,
			},
			1279: {
				perPage: 4,
			},
		},
	}).mount()
}
